import { Record } from 'immutable';
export default class MessageSettings extends Record({
  meetingsLinkId: null,
  meetingsLinkText: null
}) {}